// FIXME: It's a crutch, because base64 strings are too large (e.g. 16 megabytes)!
//  Need to access the audio file directly, by using a custom endpoint,
//  that is intercepted in SW e.g. "/sw/named-cache/audioFile/[chapter_id]"
//  But it's not working with mp3 file for some reason. Need to investigate!
export const CUSTOM_EVENT_TYPE_NEW_PULLED_AUDIO_FILE_SRC = "sw/pulled_audio_src_success";
// ================================================================================

// Is used to prompt user to install an app.
export const WINDOW_KEY_INSTALL_EVENT = "installEvent";
export const CUSTOM_EVENT_TYPE_STASH_INSTALL_PROMPT = "stashInstallEvent";

export const STORAGE_KEY_IS_USER_CANCELED_AUTO_DOWNLOADING = "isUserCanceledPWADownload";

// If needed, create a unique constant for the process of "download website".
export const ID_PROCESS_CACHE_URLS = "cache_urls";

export const SW_EVENTS_TYPES_FROM = {
  UPDATE_NAMED_CACHE_KEYS_AVAILABLE: "updateNamedCacheKeysAvailable",
  GET_FROM_NAMED_CACHE_SUCCESS: "getFromNamedCacheSuccess",
  START_DOWNLOAD_URLS: "startDownloadUrls",
  CANCEL_DOWNLOAD_URLS: "cancelDownloadUrls",
  ERROR_DOWNLOAD_URLS: "errorDownloadUrls",
  END_DOWNLOAD_URLS: "endDownloadUrls",
  DOWNLOAD_URLS_PROGRESS: "downloadUrlsProgress",
  GET_INIT_DATA_SUCCESS: "getInitDataSuccess",
};

export const SW_EVENTS_TYPES_TO = {
  CANCEL_PROCESS: "cancelProcess",
  CACHE_URLS: "cacheUrls",
  REMOVE_URLS: "removeUrls",
  GET_INIT_DATA: "getInitData",

  ADD_TO_CACHE: "addToNamedCache",
  REMOVE_FROM_CACHE: "removeFromNamedCache",
  GET_FROM_CACHE: "getFromNamedCache",
  CLEAR_NAMED_CACHES: "clearNamedCaches",
  CLEAR_WEBSITE_DATA: "clearWebsiteData",
};

export const NAMED_CACHE_NAME = {
  BOOK_DATA: "bookData",
  WAVEFORM: "waveform",
  AUDIO_FILE: "audioFile",

  OFFLINE_HISTORY_READ: "offlineReadHistory",
  OFFLINE_HISTORY_LISTEN: "offlineListenHistory",
};

export const NAMED_CACHE_NAMES = Object.values(NAMED_CACHE_NAME);
